var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('slide-transition',[_c('router-view',{attrs:{"name":"stakeholderSearchWrapper"}})],1),_vm._v(" "),_c('slide-transition',[_c('keep-alive',[_c('router-view')],1)],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }